import { render, staticRenderFns } from "./render-answer.vue?vue&type=template&id=573df2f2&scoped=true&"
import script from "./render-answer.vue?vue&type=script&lang=ts&"
export * from "./render-answer.vue?vue&type=script&lang=ts&"
import style0 from "./render-answer.vue?vue&type=style&index=0&id=573df2f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573df2f2",
  null
  
)

export default component.exports